var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"popRefund",staticClass:"pop notice",attrs:{"id":"popRefund"},on:{"click":_vm.popClose}},[_c('div',{staticClass:"popBody"},[_vm._m(0),_vm._m(1),_c('button',{on:{"click":_vm.popClose}},[_c('span',[_vm._v("確認")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"title"},[_vm._v("退款流程及方式")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('ol',[_c('li',[_vm._v("已經完成接單的訂單，無法線上退款。")]),_c('li',[_vm._v(" 若需退單退款，請直接聯絡門市人員，門市人員確認訂單狀況，會協助進行退單退款。 ")])])
}]

export { render, staticRenderFns }